import React, { useState, useEffect } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Catalog',
  href: '#catalog'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Publisher',
  href: '#authors'
}, {
  label: 'Policies',
  href: '#policies'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-ink/95 backdrop-blur border-b border-white/10' : 'bg-transparent'}`} data-id="element-191" data-mp="ehb8xseu005i">
      <nav className="mx-auto max-w-6xl px-6 h-20 flex items-center justify-between" data-id="element-192" data-mp="1pwq8n3yfd64b">
        <a href="#top" className="flex flex-col leading-none" data-id="element-193" data-mp="1kyycfxqqyxub">
          <span className="font-serif text-2xl text-paper tracking-wide" data-id="element-194" data-mp="9p964502q34l">Deleon</span>
          <span className="text-[0.6rem] uppercase tracking-[0.35em] text-gold-light" data-id="element-195" data-mp="enar4vh28cip">
            Publishing LLC
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-7" data-id="element-196" data-mp="jn6tkqa3zvw5">
          {links.map(l => <li key={l.href} data-id="element-197" data-mp="okfeuzqk0g1m">
              <a href={l.href} className="text-sm text-paper/80 hover:text-gold-light transition-colors tracking-wide" data-id="element-198" data-mp="ojnp45jn1cj9">
                {l.label}
              </a>
            </li>)}
        </ul>

        <button className="md:hidden text-paper" onClick={() => setOpen(o => !o)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-199" data-mp="v4kbzzsrhvx">
          {open ? <XIcon size={26} data-id="element-200" data-mp="34c36qgqpnidk" /> : <MenuIcon size={26} data-id="element-201" data-mp="34cmfp7yduwfg" />}
        </button>
      </nav>

      {open && <div className="md:hidden bg-ink/98 border-t border-white/10" data-id="element-202" data-mp="39ao6yg5yq220">
          <ul className="flex flex-col px-6 py-4" data-id="element-203" data-mp="31arrl211lplm">
            {links.map(l => <li key={l.href} data-id="element-204" data-mp="2wcgcocvw4owj">
                <a href={l.href} onClick={() => setOpen(false)} className="block py-3 text-paper/85 hover:text-gold-light tracking-wide" data-id="element-205" data-mp="2wbf36cuiwagx">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </div>}
    </header>;
}